import { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.logoContainer}>
        <Link to="/" style={styles.logoLink}>
          <img 
            src="./Assets/Images/logoDownloadFull.png"
            alt="Day By Data Logo"
            style={styles.logoImage}
          />
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <button 
        style={styles.menuButton}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div style={{
          ...styles.menuBar,
          transform: isMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'
        }}/>
        <div style={{
          ...styles.menuBar,
          opacity: isMenuOpen ? 0 : 1
        }}/>
        <div style={{
          ...styles.menuBar,
          transform: isMenuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'
        }}/>
      </button>

      {/* Desktop Links */}
      <div style={styles.desktopLinks}>
        <Link to="/" style={styles.link}>About</Link>
        <Link to="/support" style={styles.link}>Support</Link>
        <Link to="/social" style={styles.link}>Social</Link>
        <Link to="/privacy" style={styles.link}>Privacy</Link>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div style={styles.mobileMenu}>
          <Link to="/" style={styles.mobileLink} onClick={() => setIsMenuOpen(false)}>About</Link>
          <Link to="/support" style={styles.mobileLink} onClick={() => setIsMenuOpen(false)}>Support</Link>
          <Link to="/social" style={styles.mobileLink} onClick={() => setIsMenuOpen(false)}>Social</Link>
          <Link to="/privacy" style={styles.mobileLink} onClick={() => setIsMenuOpen(false)}>Privacy</Link>
        </div>
      )}
    </nav>
  );
}

const styles = {
  nav: {
    padding: '1rem 2rem',
    backgroundColor: '#fffef7',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    fontFamily: '"Bodoni Moda", serif',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logoLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  logoImage: {
    height: '40px',
    width: 'auto',
  },
  desktopLinks: {
    display: 'flex',
    gap: '2rem',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  link: {
    textDecoration: 'none',
    color: '#0a0a0a',
    fontSize: '1.1rem',
    transition: 'color 0.2s ease',
    ':hover': {
      color: '#666',
    },
  },
  menuButton: {
    display: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0.5rem',
    '@media (max-width: 768px)': {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
  },
  menuBar: {
    width: '24px',
    height: '2px',
    backgroundColor: '#0a0a0a',
    transition: 'all 0.3s ease',
  },
  mobileMenu: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fffef7',
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    '@media (min-width: 769px)': {
      display: 'none',
    },
  },
  mobileLink: {
    textDecoration: 'none',
    color: '#0a0a0a',
    fontSize: '1.1rem',
    padding: '0.75rem 1rem',
    transition: 'background-color 0.2s ease',
    ':hover': {
      backgroundColor: 'rgba(0,0,0,0.05)',
    },
  },
};

export default Navbar;